import React from "react";
import { Loader } from "./Loader";

const Button = ({
  type = "primary",
  size = "medium",
  onClick,
  className,
  children,
  isLoading,
  disabled,
}) => {
  // Button size styles
  const sizeStyles = {
    small: "py-2.5 px-4 text-sm",
    medium: "py-3 px-6 text-sm",
    large: "py-4 px-8 text-lg",
    icon: "px-3 text-xs",
  };

  // Button type styles
  const typeStyles = {
    primary:
      "bg-[#2A4258] hover:bg-[#4E6C83] text-white border border-[#2A4258]",
    primaryNoHover: "bg-[#2A4258] text-white border border-[#2A4258]",
    secondary:
      "bg-gray-200 hover:bg-gray-300 text-black border border-gray-300",
    danger: "bg-red-500 hover:bg-red-600 text-white border border-red-500",
    outline:
      "bg-transparent hover:bg-[#4E6C83] text-[#2A4258] hover:text-white border border-[#2A4258]",
  };

  return (
    <button
      disabled={disabled || isLoading}
      onClick={onClick}
      type={type || "submit"}
      className={`${sizeStyles[size]} ${typeStyles[type]} ${className} font-semibold rounded-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none`}
    >
      {isLoading ? <Loader /> : children}
    </button>
  );
};

export default Button;
